/* eslint-disable indent */
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

const formatPercent = (
	input?: number | string | undefined,
	minimumFractionDigits?: number,
): string => {
	if (input === undefined) return ''
	return input.toLocaleString(undefined, {
		style: 'percent',
		minimumFractionDigits: minimumFractionDigits ?? 2,
	})
}

const formatLocaleShortDate = (input: Date | string | null, ifUndefinedText?: string, locale?: string): string => {
	if (input instanceof Date) return input.toLocaleDateString(locale ?? 'en-US')
	return input ? new Date(input).toLocaleDateString(locale ?? 'en-US') : ifUndefinedText ?? 'n/a'
}

const formatLocaleShortDateTime = (
	input: Date | string | null | undefined,
	timezone: string,
	ifUndefinedText?: string,
): string => {
	if (!input) return ifUndefinedText ?? 'n/a'
	// US date format
	return dayjs(input).utc(true).tz(timezone).format('DD/MM/YYYY h:mm A')
}

const formatLocaleTime = (timezone: string, input?: Date | string, ifUndefinedText?: string): string => {
	if (!input) return ifUndefinedText ?? 'n/a'
	return dayjs(input).utc(true).tz(timezone).format('h:mm A')
}

const formatTimelineDate = (timezone: string, input: Date | string, ifUndefinedText?: string): string => {
	if (!input) return ifUndefinedText ?? 'n/a'
	const months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.']
	const d = dayjs(input).utc(true).tz(timezone)
	return `${months[d.month()]} ${d.date()}`
}

const formatNumberAsLetter = (input: number | string) =>
	String.fromCharCode(64 + (typeof input === 'number' ? input : parseInt(input)))

const getColorLevel = (wbsIndex: number) => {
	const bit8 = 255 - (wbsIndex - 1) * 25
	return `rgba(${bit8},${bit8},${bit8}, .5)`
}

export {
	formatPercent,
	formatLocaleShortDate,
	getColorLevel,
	formatLocaleShortDateTime,
	formatNumberAsLetter,
	formatLocaleTime,
	formatTimelineDate,
}
